import clsx from 'clsx';
import { Base } from '../../Base';
import { jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "Tld-root_3QgOX"
};
function Tld({
  children = '',
  className,
  ...extraProps
}) {
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "span",
    weight: "semibold",
    className: clsx(!extraProps.color && styles.root, className),
    ...extraProps,
    children: [".", children]
  });
}
export { Tld };